import React, { useState } from 'react';
import { X, ArrowRightLeft, FileCode, Edit3 } from 'lucide-react';

const TaskCompareModal = ({ isOpen, onClose, task }) => {
    const [viewMode, setViewMode] = useState('split'); // split, original, generated

    if (!isOpen || !task) return null;

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(15, 23, 42, 0.8)', zIndex: 9999,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            backdropFilter: 'blur(4px)'
        }}>
            <div style={{
                background: '#1e293b',
                width: '95vw',
                height: '90vh',
                borderRadius: '0.75rem',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                display: 'flex', flexDirection: 'column',
                overflow: 'hidden', border: '1px solid #334155'
            }}>
                {/* Header */}
                <div style={{
                    padding: '1rem 1.5rem', borderBottom: '1px solid #334155',
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    backgroundColor: '#0f172a'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <h2 style={{ margin: 0, color: 'white', display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '1.25rem' }}>
                            <ArrowRightLeft size={20} className="text-blue-400" />
                            Content Compare: {task.live_url || 'New Draft'}
                        </h2>
                        <span style={{ backgroundColor: '#3b82f6', color: 'white', padding: '0.25rem 0.5rem', borderRadius: '9999px', fontSize: '0.75rem', fontWeight: 'bold' }}>
                            {task.task_type}
                        </span>
                    </div>
                    
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <div style={{ display: 'flex', backgroundColor: '#334155', borderRadius: '0.5rem', overflow: 'hidden' }}>
                            <button 
                                onClick={() => setViewMode('split')}
                                style={{ padding: '0.5rem 1rem', background: viewMode === 'split' ? '#2563eb' : 'transparent', color: 'white', border: 'none', cursor: 'pointer', fontSize: '0.875rem' }}
                            >Split View</button>
                            <button 
                                onClick={() => setViewMode('original')}
                                style={{ padding: '0.5rem 1rem', background: viewMode === 'original' ? '#475569' : 'transparent', color: 'white', border: 'none', cursor: 'pointer', fontSize: '0.875rem' }}
                            >Original Only</button>
                            <button 
                                onClick={() => setViewMode('generated')}
                                style={{ padding: '0.5rem 1rem', background: viewMode === 'generated' ? '#059669' : 'transparent', color: 'white', border: 'none', cursor: 'pointer', fontSize: '0.875rem' }}
                            >Generated Only</button>
                        </div>
                        <button onClick={onClose} style={{ background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer' }}>
                            <X size={24} />
                        </button>
                    </div>
                </div>

                {/* Body */}
                <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
                    
                    {/* Original Panel */}
                    {(viewMode === 'split' || viewMode === 'original') && (
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', borderRight: viewMode === 'split' ? '1px solid #334155' : 'none' }}>
                            <div style={{ padding: '0.75rem', backgroundColor: '#1e293b', color: '#94a3b8', borderBottom: '1px solid #334155', display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', fontWeight: 'bold' }}>
                                <FileCode size={16} /> ORIGINAL SOURCE
                            </div>
                            <div style={{ flex: 1, padding: '1rem', overflowY: 'auto', backgroundColor: '#0f172a', color: '#cbd5e1', fontFamily: 'monospace', fontSize: '0.875rem', whiteSpace: 'pre-wrap' }}>
                                {task.topic_or_source}
                            </div>
                        </div>
                    )}

                    {/* Generated Panel */}
                    {(viewMode === 'split' || viewMode === 'generated') && (
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            <div style={{ padding: '0.75rem', backgroundColor: '#1e293b', color: '#10b981', borderBottom: '1px solid #334155', display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', fontWeight: 'bold' }}>
                                <Edit3 size={16} /> AI GENERATED OUTPUT
                            </div>
                            <div style={{ flex: 1, padding: '1rem', overflowY: 'auto', backgroundColor: '#0f172a', color: '#cbd5e1', fontFamily: 'monospace', fontSize: '0.875rem', whiteSpace: 'pre-wrap' }}>
                                {task.generated_content ? task.generated_content : "No generated content available for this task (likely completed before Compare feature was added)."}
                            </div>
                        </div>
                    )}
                </div>
                
                {/* Footer */}
                <div style={{ padding: '1rem', borderTop: '1px solid #334155', backgroundColor: '#1e293b', display: 'flex', justifyContent: 'flex-end' }}>
                    <button onClick={onClose} className="btn bg-gray-600 hover:bg-gray-500 text-white font-bold py-2 px-6 rounded">
                        Close Modal
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TaskCompareModal;
